import type { AllowedComponentProps, Component, VNodeProps } from 'vue'
import { useEventBus } from '@vueuse/core'
import type { CustomDialog, Dialog, DialogEvent } from '../ui-components/DTDialog/types'

type ComponentProps<C extends Component> = C extends new (...args: any) => any
  ? Omit<InstanceType<C>['$props'], keyof VNodeProps | keyof AllowedComponentProps>
  : never

export default () => {
  const bus = useEventBus<DialogEvent>('dt_dialog')

  const confirm = (opts: Dialog | CustomDialog) => {
    const defaults = { okTitle: 'Confirm', cancelTitle: 'Cancel' }
    return new Promise<boolean | undefined>((resolve) => {
      bus.emit({
        id: `DTDialogEvent-${crypto.randomUUID()}`,
        dialog: { ...defaults, ...opts },
        type: 'add',
        resolve,
      })
    })
  }

  const confirmDelete = (opts: Dialog) => {
    const defaults = {
      okTitle: 'Delete',
      okVariant: 'red',
      cancelTitle: 'Cancel',
    } as Dialog
    return confirm({ ...defaults, ...opts })
  }

  const customDialog = <TComponent extends Component>({ component, props }: { component: TComponent, props: ComponentProps<TComponent> }) => confirm({
    component,
    props,
  })

  return {
    confirm,
    confirmDelete,
    customDialog,
  }
}
